export class ListDataCatalogDatasetEventsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "kinds",
            "baseName": "kinds",
            "type": "Array<DataCatalogDatasetEventKind>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDataCatalogDatasetEventsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
